import { inject, Injectable, Signal, DOCUMENT } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, map, merge, startWith, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InternetService {
  isOnline: Signal<boolean>;

  private window = inject(DOCUMENT).defaultView!;

  constructor() {
    const on$ = fromEvent(this.window, 'online').pipe(map(() => true));
    const off$ = fromEvent(this.window, 'offline').pipe(map(() => false));

    // Fusion des événements du navigateur ET de la vérification ping
    this.isOnline = toSignal(merge(on$, off$, onlineStatus$).pipe(startWith(true)), { initialValue: true });
  }
}

export const onlineStatus$ = new Subject<boolean>();

export async function isReallyOnline(pingUrl = 'testOnline.ico'): Promise<boolean> {
  try {
    const response = await fetch(pingUrl, {
      method: 'GET',
      cache: 'no-store',
    });
    onlineStatus$.next(response.ok);
    return response.ok;
  } catch (error) {
    onlineStatus$.next(false);
    return false;
  }
}
